import type { FaireProductEntity } from "../../entity_types/product";

export const p_gjqrgvgkbd: FaireProductEntity = {
  token: "p_gjqrgvgkbd",
  type: "product",
  name: "Cubic Zirconia Clover Pendant Necklace",
  brandToken: "b_c3xmn96nkh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/00827adfaa623f6f097a0d878e3dd3110f5ed79c57a9c062c8830e8be0ab92b0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/277c510bdbe4f1d0f8d282b561419713d9f85f1859fe6154f6daf48f2dbb27e8.jpeg",
    "https://cdn.faire.com/fastly/18c770b505837d2843fad8f5308acfc73791ecd78671978b78e77ecae9be0cf5.jpeg",
    "https://cdn.faire.com/fastly/5f9b187f16385124ebfb7cb28a70db0a759bbc33747b7f2279aac017f55f8348.jpeg",
  ],
  priceDollars: 8.01,
  description:
    'Necklace Size : 16" + 2" L\nDecor Size : 0.4" X 0.4"\nElegant clover pendant necklace designed with sparkling stone accents for a refined, timeless look. A symbol-inspired piece ideal for everyday styling, gifting, or seasonal collections. Perfect for boutiques seeking meaningful accessories that blend charm, versatility, and lasting appeal.',
  tags: [],
  msrpDollars: 16.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:43.433Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
